((BundleCollection) => {
  'use strict';

  const dom = {};
  let bundleProducts = {};
  const bundleSize = window.bvaccel ? window.bvaccel.bundleTotalProductCount : 0;

  const cacheDom = () => {
    dom.$bundleToggleTargets = $('.collection-bundle__indicators, .collection-bundle__toggle');
    dom.$bundleIndicator = $('.collection-bundle__indicator');
    dom.$bundleToggle = $('.collection-bundle__toggle');
    dom.$bundleItemsWrapper = $('.collection-bundle__items-wrapper');
    dom.$bundleItem = $('.collection-bundle__item');
    dom.$bundleItemRemove = $('.collection-bundle__item-remove');
    dom.$bundleCta = $('.collection-bundle__cta');
    dom.$productGridItemLinks = $('[data-product-grid-item] a');
    dom.$productGridItems = $('[data-product-grid-item]');
  };

  const bindUIActions = () => {
    dom.$bundleToggleTargets.on('click', () => {
      dom.$bundleToggle.find('svg').toggle();
      dom.$bundleItemsWrapper.slideToggle();
    });

    dom.$bundleItemRemove.on('click', function (evt) {
      const idx = parseInt($(this).attr('data-index'), 10);
      const id = $(this).attr('data-id');
      let bundleIndex = 0;
      Object.keys(bundleProducts).forEach((key) => {
        bundleProducts[key].some((item, i) => {
          if (item.variant_id === id && idx === bundleIndex) {
            bundleProducts[key].splice(i, 1);
            return true;
          }
          bundleIndex++;
          return false;
        });
      });
      updateUI();
    });

    dom.$bundleCta.on('click', () => {
      const totalProducts = Object.values(bundleProducts).flat().length;
      if (totalProducts == bundleSize) {
        const bundleId = Date.now();

        // build an object of unique items
        const uniqueItems = Object.values(bundleProducts).reduce((acc, val) => {
          val.forEach((product) => {
            acc[product.variant_id] = acc[product.variant_id] ? acc[product.variant_id] + 1 : 1;
          });
          return acc;
        }, {});

        // build an array of unique items
        let items = [];
        for (const [id, quantity] of Object.entries(uniqueItems)) {
          items.push({
            id,
            quantity,
            properties: {
              _Bundle_Id: bundleId,
              _Bundle_Size: bundleSize,
              Bundle: 'Bundle of ' + bundleSize,
            },
          });
        }

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: items }),
        })
          .then((response) => {
            InlineCart.miniCartLoad(false, true);
          })
          .catch(console.error);

        bundleProducts = {};
        updateUI();
      }
    });

    dom.$productGridItemLinks.on('click', function (evt) {
      evt.preventDefault();

      $(this).closest('[data-product-grid-item]').find('.js-quickview-cta').trigger('click');
    });
  };

  const updateUI = () => {
    dom.$bundleItem.each((index, el) => {
      const $this = $(el);
      const $bundleItemRemove = $(dom.$bundleItemRemove[index]);
      const $indicator = $(dom.$bundleIndicator[index]);
      const $image = $this.find('.collection-bundle__item-image');
      const $placeholder = $this.find('.collection-bundle__item-placeholder');
      const $remove = $this.find('.collection-bundle__item-remove');

      const bundleProduct = Object.values(bundleProducts).flat()[index];
      if (bundleProduct) {
        $indicator.addClass('is-active');
        $bundleItemRemove.attr('data-id', bundleProduct.variant_id);
        $image.attr('src', bundleProduct.image).show();
        $placeholder.hide();
        $remove.show();
      } else {
        $indicator.removeClass('is-active');
        $image.attr('src', '').hide();
        $placeholder.show();
        $remove.hide();
      }
    });
    const totalProducts = Object.values(bundleProducts).flat().length;
    if (totalProducts == bundleSize) {
      dom.$bundleCta.text('Add to Cart').removeClass('is-disabled');
    } else {
      const itemsLeft = bundleSize - totalProducts;
      dom.$bundleCta.text('Add ' + itemsLeft + ' Item' + (itemsLeft > 1 ? 's' : '')).addClass('is-disabled');
    }
  };

  const addBundleProduct = (bundleProduct) => {
    const collection = bundleProduct.collection;
    const bundleProductVariant = bundleProduct.variant_id;

    bundleProducts[collection] = bundleProducts[collection] || [];

    const products = bundleProducts[collection];

    products.push(bundleProduct);

    const currentCollectionMetadata = window.bvaccel.bundleMultipleCollections.find((obj) => {
      return obj.collectionHandle === collection;
    });

    if (currentCollectionMetadata) {
      const limitForThisCollection = parseInt(currentCollectionMetadata.collectionMaxItemPerBundle, 10);
      if (products.length > limitForThisCollection) {
        products.splice(0, 1);
      }

      updateUI();

      if (dom.$bundleToggle.find('.chevron-down:visible').length === 1) {
        dom.$bundleToggle.find('svg').toggle();
        dom.$bundleItemsWrapper.slideToggle();
      }
    }
  };

  const initProductGridItems = () => {
    dom.$productGridItems.each(function () {
      const $this = $(this);
      const $productPrice = $this.find('.product-grid-item--price');
      const $productComparePrice = $this.find('.product-grid-item--price-original');
      const collection = $this.attr('data-collection-handle');
      const currentCollectionMetadata = window.bvaccel.bundleMultipleCollections.find((obj) => {
        return obj.collectionHandle === collection;
      });

      if ($productComparePrice.length === 0) {
        $(
          '<span class="original-price money product-grid-item--price-original">' + $productPrice.text() + '</span>'
        ).prependTo($productPrice.parent());
      }
      $productPrice.text(`$${currentCollectionMetadata.collectionNewPrice}`);
    });

    $('.js-quickview-cta').text('View Product');
  };

  const init = () => {
    cacheDom();
    bindUIActions();
    initProductGridItems();
  };

  BundleCollection.init = init;
  BundleCollection.addBundleProduct = addBundleProduct;
})((window.BundleCollection = window.BundleCollection || {}));
